import { createReducer, on } from '@ngrx/store';

import { PagedBase } from '../general/models/general';
import { IInvitation } from './models/invitations';
import { ITeamMember } from './models/team';
import * as actions from './team.actions';

export const TEAM_FEATURE_KEY = 'team';

export interface TeamState extends PagedBase {
  teamMembers: ITeamMember[];
  invitations: IInvitation[];
  isLoading: boolean;
}

export const initialState: TeamState = {
  teamMembers: [],
  invitations: [],
  isLoading: false,
  hasMore: false,
  pageNumber: 1,
  pageSize: 0,
  totalCount: undefined,
  totalPages: 0,
};

export const teamReducer = createReducer(
  initialState,
  on(actions.getAllTeamMembers, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getAllTeamMembersSuccess,
    (state, { pagedTeamMembers: { items, ...rest } }) => ({
      ...state,
      ...rest,
      teamMembers:
        rest.pageNumber === 1 ? [...items] : [...state.teamMembers, ...items],
      isLoading: false,
    }),
  ),
  on(actions.getInvitations, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    actions.getInvitationsSuccess,
    (state, { pagedInvitations: { items, ...rest } }) => ({
      ...state,
      ...rest,
      invitations:
        rest.pageNumber === 1 ? [...items] : [...state.invitations, ...items],
      isLoading: false,
    }),
  ),
);
